import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { MESSAGES_ADD_DIRECTIONS } from "../../../../packages/constants";
import { authSelectors } from "../../../auth";
import { useControlContext } from "../../../control";
import { addMessages, postMessageText } from "../../actions";
import { isButtonCallback, isButtonLink } from "../../type-guards";
import { createMessageText, getSendMessageButtonData } from "../../providers";
import { selectLastMessage } from "../../selectors";
import { useReplyMessage } from "./use-reply-message";
import type { SyntheticEvent } from "react";
import type {
  PostMessageData,
  Button,
  ButtonCallback,
  ButtonLink,
  Message,
  MessageButtons,
  Entity,
} from "../../types";

const { selectUserId } = authSelectors;

export const useMessageButtons = (message: MessageButtons) => {
  const dispatch = useAppDispatch();
  const { api } = useControlContext();
  const authorId = useAppSelector(selectUserId);
  const lastMessage = useAppSelector(selectLastMessage);
  const { postMessageTextApi } = api;
  const isLastMessage = message.id === lastMessage.id;
  const { replyMessage, replyMessageId } = useReplyMessage();

  const addMessageIntoStore = (msg: Message) => {
    const params = {
      messages: [msg],
      direction: MESSAGES_ADD_DIRECTIONS.END,
    };

    dispatch(addMessages(params));
  };

  const handleClickLink = (button: ButtonLink) => {
    const isExternalURL = new URL(button.url).origin !== location.origin;

    window.open(button.url, isExternalURL ? "_blank" : "_self");
  };

  const sendMessage = (msg: PostMessageData, traceId: string) => {
    const params = {
      postMessageTextApi,

      traceId,
      message: msg,
    };

    dispatch(postMessageText(params));
  };

  const handleClickCallback = (button: ButtonCallback) => {
    // Добавление сообщения с статусом SEND в redux-store перед отправкой
    const { title: text } = button;
    const message = { text, entities: [] as Array<Entity> };
    const params = { authorId, message, replyMessage };
    const messageButtonToAdd = createMessageText(params);

    addMessageIntoStore(messageButtonToAdd);

    // Отправка сообщения
    const messageButtonToSend = getSendMessageButtonData(
      button,
      messageButtonToAdd.traceId,
      replyMessageId
    );

    const { traceId } = messageButtonToAdd;

    sendMessage(messageButtonToSend, traceId);
  };

  const handleButtonClick = (button: Button) => (e: SyntheticEvent) => {
    e.preventDefault();

    if (isButtonLink(button)) {
      handleClickLink(button);
    }

    if (isButtonCallback(button)) {
      handleClickCallback(button);
    }
  };

  return { isLastMessage, handleButtonClick };
};
